import type { UserRole } from '@doneverse/shared'

export interface ImpersonatedUser {
  id: string
  name: string
  email: string
  role: UserRole
  returnTo?: string
}

export function getCurrentPath(location: Pick<Location, 'pathname' | 'search' | 'hash'>): string {
  return `${location.pathname}${location.search}${location.hash}`
}

export function getImpersonationReturnTo(user: ImpersonatedUser | null | undefined): string {
  return user?.returnTo?.startsWith('/') ? user.returnTo : '/admin/users'
}

let impersonatedUserIdGetter: () => string | null = () => null

export function setImpersonatedUserIdGetter(getter: () => string | null): void {
  impersonatedUserIdGetter = getter
}

export function getImpersonatedUserId(): string | null {
  return impersonatedUserIdGetter()
}
